import { FC, ReactNode } from 'react'
import { Form, InputGroup, Input } from 'rsuite';

interface Meta {
  touched: boolean;
  error: string;
}

interface ComponentProps {
  icon?: ReactNode;
  input: any;
  placeholder: string;
  meta?: Meta;
  type: string;
  label?: string;
  disabled?: boolean;
  readOnly?: boolean;
  name?: string;
}

const CustomInput: FC<ComponentProps> = ({ placeholder, input, type, disabled }) => (
  <Input
    placeholder={placeholder}
    {...input}
    type={type}
    autoComplete="off"
    disabled={disabled}
  />
)

const InputWithLabel: FC<ComponentProps> = (props: ComponentProps) => {
  const { placeholder = "Input", icon, meta, input, type = "text", label, disabled, readOnly = false, name = 'input' } = props
  return (
    <Form.Group>
      <Form.ControlLabel>{label}</Form.ControlLabel>
      <InputGroup inside style={{ width: '100%' }}>
        <Form.Control
          accepter={CustomInput}
          placeholder={placeholder}
          input={input}
          name={`${name}-form-control`}
          type={type}
          disabled={disabled}
          errorMessage={meta?.touched && meta.error}
          readOnly={readOnly}
        />
        {!!icon && icon
        }
      </InputGroup>
    </Form.Group>
  );
}

export default InputWithLabel